import "core-js/modules/es.array.reverse.js";
var _class, _SdmxServerStratum;
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import i18next from "i18next";
import { action, computed, makeObservable } from "mobx";
import RequestErrorEvent from "terriajs-cesium/Source/Core/RequestErrorEvent";
import Resource from "terriajs-cesium/Source/Core/Resource";
import filterOutUndefined from "../../../Core/filterOutUndefined";
import flatten from "../../../Core/flatten";
import isDefined from "../../../Core/isDefined";
import { regexMatches } from "../../../Core/regexMatches";
import TerriaError from "../../../Core/TerriaError";
import SdmxCatalogGroupTraits from "../../../Traits/TraitsClasses/SdmxCatalogGroupTraits";
import CatalogGroup from "../CatalogGroup";
import CommonStrata from "../../Definition/CommonStrata";
import LoadableStratum from "../../Definition/LoadableStratum";
import proxyCatalogItemUrl from "../proxyCatalogItemUrl";
import StratumOrder from "../../Definition/StratumOrder";
import SdmxJsonCatalogItem from "./SdmxJsonCatalogItem";
export let SdmxServerStratum = (_class = (_SdmxServerStratum = class SdmxServerStratum extends LoadableStratum(SdmxCatalogGroupTraits) {
  static async load(catalogGroup) {
    var _await$loadSdmxJsonSt, _categorySchemeRespon, _categorySchemeRespon2, _categorySchemeRespon3;
    // Load agency schemes (may be undefined)
    const agencySchemes = (_await$loadSdmxJsonSt = await loadSdmxJsonStructure(proxyCatalogItemUrl(catalogGroup, "".concat(catalogGroup.url, "/agencyscheme/")), true)) === null || _await$loadSdmxJsonSt === void 0 || (_await$loadSdmxJsonSt = _await$loadSdmxJsonSt.data) === null || _await$loadSdmxJsonSt === void 0 ? void 0 : _await$loadSdmxJsonSt.agencySchemes;

    // Load category schemes (may be undefined)
    const categorySchemeResponse = await loadSdmxJsonStructure(proxyCatalogItemUrl(catalogGroup, "".concat(catalogGroup.url, "/categoryscheme?references=parentsandsiblings")), true);
    let dataflows = categorySchemeResponse === null || categorySchemeResponse === void 0 || (_categorySchemeRespon = categorySchemeResponse.data) === null || _categorySchemeRespon === void 0 ? void 0 : _categorySchemeRespon.dataflows;

    // If no dataflows from category schemes -> try getting all of them through `dataflow` endpoint
    if (!isDefined(dataflows)) {
      var _await$loadSdmxJsonSt2;
      dataflows = (_await$loadSdmxJsonSt2 = await loadSdmxJsonStructure(proxyCatalogItemUrl(catalogGroup, "".concat(catalogGroup.url, "/dataflow/")), true)) === null || _await$loadSdmxJsonSt2 === void 0 || (_await$loadSdmxJsonSt2 = _await$loadSdmxJsonSt2.data) === null || _await$loadSdmxJsonSt2 === void 0 ? void 0 : _await$loadSdmxJsonSt2.dataflows;
      if (!isDefined(dataflows)) {
        throw new TerriaError({
          title: i18next.t("models.sdmxServerStratum.loadDataErrorTitle"),
          message: i18next.t("models.sdmxServerStratum.loadDataErrorMessage")
        });
      }
    }
    return new SdmxServerStratum(catalogGroup, {
      agencySchemes,
      categorySchemes: categorySchemeResponse === null || categorySchemeResponse === void 0 || (_categorySchemeRespon2 = categorySchemeResponse.data) === null || _categorySchemeRespon2 === void 0 ? void 0 : _categorySchemeRespon2.categorySchemes,
      categorisations: categorySchemeResponse === null || categorySchemeResponse === void 0 || (_categorySchemeRespon3 = categorySchemeResponse.data) === null || _categorySchemeRespon3 === void 0 ? void 0 : _categorySchemeRespon3.categorisations,
      dataflows
    });
  }
  duplicateLoadableStratum(model) {
    return new SdmxServerStratum(model, this.sdmxServer);
  }
  constructor(catalogGroup, sdmxServer) {
    super();
    this.catalogGroup = catalogGroup;
    this.sdmxServer = sdmxServer;
    _defineProperty(this, "dataflowTree", {});
    makeObservable(this);

    // If categorisations exist => organise Dataflows into a tree!
    if (isDefined(this.sdmxServer.categorisations)) {
      this.sdmxServer.categorisations.forEach(categorisiation => {
        var _parseSdmxUrn;
        const categorySchemeUrn = parseSdmxUrn(categorisiation.target);
        const agencyId = categorySchemeUrn === null || categorySchemeUrn === void 0 ? void 0 : categorySchemeUrn.agencyId;
        const categorySchemeId = categorySchemeUrn === null || categorySchemeUrn === void 0 ? void 0 : categorySchemeUrn.resourceId;
        const categoryIds = categorySchemeUrn === null || categorySchemeUrn === void 0 ? void 0 : categorySchemeUrn.descendantIds; // Only support 1 level of categorisiation for now

        const dataflowId = (_parseSdmxUrn = parseSdmxUrn(categorisiation.source)) === null || _parseSdmxUrn === void 0 ? void 0 : _parseSdmxUrn.resourceId;
        if (!isDefined(agencyId) || !isDefined(categorySchemeId) || !isDefined(categoryIds) || !isDefined(dataflowId)) return;
        let agencyNode = this.dataflowTree[agencyId];

        // Create agency node if it doesn't exist
        if (!isDefined(agencyNode)) {
          const agency = this.getAgency(agencyId);
          if (!isDefined(agency)) return;
          this.dataflowTree[agencyId] = {
            type: "agencyScheme",
            item: agency,
            members: {}
          };
          agencyNode = this.dataflowTree[agencyId];
        }
        let categorySchemeNode = agencyNode.members[categorySchemeId];

        // Create categoryScheme node if it doesn't exist
        if (!isDefined(categorySchemeNode)) {
          const categoryScheme = this.getCategoryScheme(categorySchemeId);
          if (!isDefined(categoryScheme)) return;
          agencyNode.members[categorySchemeId] = {
            type: "categoryScheme",
            item: categoryScheme,
            members: {}
          };
          categorySchemeNode = agencyNode.members[categorySchemeId];
        }
        let categoryParentNode = categorySchemeNode;

        // Make category nodes (may be nested)
        categoryIds.forEach(categoryId => {
          // Create category node if it doesn't exist
          if (!isDefined(categoryParentNode.members[categoryId])) {
            let category;

            // Find current categoryId in parent categoryScheme or parent category
            if (categoryParentNode.type === "categoryScheme") {
              category = this.getCategoryFromCatagoryScheme(categorySchemeId, categoryId);
            } else if (categoryParentNode.type === "category") {
              var _categoryParentNode$i;
              category = this.getCategoryFromCategories((_categoryParentNode$i = categoryParentNode.item) === null || _categoryParentNode$i === void 0 ? void 0 : _categoryParentNode$i.categories, categoryId);
            }
            if (!isDefined(category)) return;
            categoryParentNode.members[categoryId] = {
              type: "category",
              item: category,
              members: {}
            };
          }
          // Swap parent node to newly created category node
          categoryParentNode = categoryParentNode.members[categoryId];
        });

        // Create dataflow!
        const dataflow = this.getDataflow(dataflowId);
        if (!isDefined(dataflow)) return;
        categoryParentNode.members[dataflowId] = {
          type: "dataflow",
          item: dataflow
        };
      });
      // No categorisations exist => add flat list of dataflows
    } else {
      this.dataflowTree = this.sdmxServer.dataflows.reduce((tree, dataflow) => {
        if (isDefined(dataflow.id)) {
          tree[dataflow.id] = {
            type: "dataflow",
            item: dataflow
          };
        }
        return tree;
      }, {});
    }
  }
  get members() {
    // Find first node in tree which has more than 1 child
    const findRootGroup = node => {
      const children = isDefined(node === null || node === void 0 ? void 0 : node.members) ? Object.values(node.members) : undefined;

      // If only 1 child -> keep searching
      return isDefined(children) && children.length === 1 ? findRootGroup(children[0]) : node;
    };
    let rootTreeNodes = Object.values(this.dataflowTree);

    // If only a single group -> try to find next nested group with more than 1 child
    if (rootTreeNodes.length === 1 && isDefined(rootTreeNodes[0])) {
      var _findRootGroup$member;
      rootTreeNodes = Object.values((_findRootGroup$member = findRootGroup(rootTreeNodes[0]).members) !== null && _findRootGroup$member !== void 0 ? _findRootGroup$member : this.dataflowTree);
    }
    return rootTreeNodes.map(node => this.getMemberId(node));
  }
  createMembers() {
    Object.values(this.dataflowTree).forEach(node => this.createMemberFromLayer(node));
  }
  createMemberFromLayer(node) {
    const layerId = this.getMemberId(node);
    if (!layerId) {
      return;
    }

    // Replace the stratum inherited from the parent group.

    // If has nested layers -> create model for CatalogGroup
    if (node.members && Object.keys(node.members).length > 0) {
      // Create nested layers

      Object.values(node.members).forEach(member => this.createMemberFromLayer(member));

      // Create group
      const existingGroupModel = this.catalogGroup.terria.getModelById(CatalogGroup, layerId);
      let groupModel;
      if (existingGroupModel === undefined) {
        groupModel = new CatalogGroup(layerId, this.catalogGroup.terria);
        this.catalogGroup.terria.addModel(groupModel);
      } else {
        groupModel = existingGroupModel;
      }
      groupModel.setTrait(CommonStrata.definition, "name", node.item.name || node.item.id);
      groupModel.setTrait(CommonStrata.definition, "members", filterOutUndefined(Object.values(node.members).map(member => this.getMemberId(member))));

      // Set group description
      if (node.item.description) {
        groupModel.setTrait(CommonStrata.definition, "description", node.item.description);
      }
      return;
    }

    // No nested layers (and type is dataflow) -> create model for SdmxJsonCatalogItem
    if (node.type !== "dataflow" || !isDefined(node.item.id) || !isDefined(node.item.agencyID)) return;
    const existingItemModel = this.catalogGroup.terria.getModelById(SdmxJsonCatalogItem, layerId);
    let itemModel;
    if (existingItemModel === undefined) {
      itemModel = new SdmxJsonCatalogItem(layerId, this.catalogGroup.terria, undefined);
      this.catalogGroup.terria.addModel(itemModel);
    } else {
      itemModel = existingItemModel;
    }
    itemModel.strata.delete(CommonStrata.definition);
    itemModel.setTrait(CommonStrata.definition, "name", node.item.name || node.item.id);
    itemModel.setTrait(CommonStrata.definition, "url", this.catalogGroup.url);
    // Set group description
    if (node.item.description) {
      itemModel.setTrait(CommonStrata.definition, "description", node.item.description);
    }
    itemModel.setTrait(CommonStrata.definition, "agencyId", node.item.agencyID);
    itemModel.setTrait(CommonStrata.definition, "dataflowId", node.item.id);
    itemModel.setTrait(CommonStrata.definition, "modelOverrides", this.catalogGroup.traits.modelOverrides.toJson(this.catalogGroup.modelOverrides));
  }
  getMemberId(node) {
    return "".concat(this.catalogGroup.uniqueId, "/").concat(node.type, "-").concat(node.item.id);
  }
  getDataflow(id) {
    if (!isDefined(id)) return;
    return this.sdmxServer.dataflows.find(d => d.id === id);
  }
  getCategoryScheme(id) {
    var _this$sdmxServer$cate;
    if (!isDefined(id)) return;
    return (_this$sdmxServer$cate = this.sdmxServer.categorySchemes) === null || _this$sdmxServer$cate === void 0 ? void 0 : _this$sdmxServer$cate.find(d => d.id === id);
  }
  getCategoryFromCatagoryScheme(categoryScheme, id) {
    if (!isDefined(id)) return;
    const resolvedCategoryScheme = typeof categoryScheme === "string" ? this.getCategoryScheme(categoryScheme) : categoryScheme;
    return this.getCategoryFromCategories(resolvedCategoryScheme === null || resolvedCategoryScheme === void 0 ? void 0 : resolvedCategoryScheme.categories, id);
  }
  getCategoryFromCategories(categories, id) {
    return isDefined(id) ? categories === null || categories === void 0 ? void 0 : categories.find(c => c.id === id) : undefined;
  }
  getAgency(id) {
    var _this$sdmxServer$agen;
    if (!isDefined(id)) return;
    const agencies = (_this$sdmxServer$agen = this.sdmxServer.agencySchemes) === null || _this$sdmxServer$agen === void 0 ? void 0 : _this$sdmxServer$agen.map(agencyScheme => agencyScheme.agencies);
    if (!isDefined(agencies)) return;
    return flatten(filterOutUndefined(agencies)).find(d => d.id === id);
  }
}, _defineProperty(_SdmxServerStratum, "stratumName", "sdmxServer"), _SdmxServerStratum), _applyDecoratedDescriptor(_class.prototype, "members", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "members"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "createMemberFromLayer", [action], Object.getOwnPropertyDescriptor(_class.prototype, "createMemberFromLayer"), _class.prototype), _class);
StratumOrder.addLoadStratum(SdmxServerStratum.stratumName);
export function parseSdmxUrn(urn) {
  if (!isDefined(urn)) return;
  // Format urn:sdmx:org.sdmx.infomodel.xxx.xxx=AGENCY:RESOURCEID(VERSION).SUBRESOURCEID.SUBSUBRESOURCEID...
  // Example urn:sdmx:org.sdmx.infomodel.categoryscheme.Category=SPC:CAS_COM_TOPIC(1.0).ECO

  // Sub resource ID and (and sub sub...) are optional
  const matches = regexMatches(/.+=(.+):(.+)\((.+)\)\.*(.*)/g, urn);
  if (matches.length >= 1 && matches[0].length >= 3 && !isDefined([0, 1, 2].find(idx => matches[0][idx] === null))) {
    return {
      agencyId: matches[0][0],
      resourceId: matches[0][1],
      version: matches[0][2],
      descendantIds: matches[0][3] !== null ? matches[0][3].split(".") : undefined
    };
  }
}
export async function loadSdmxJsonStructure(url, allowNotImplemeted) {
  try {
    return JSON.parse(await new Resource({
      url,
      headers: {
        Accept: "application/vnd.sdmx.structure+json; charset=utf-8; version=1.0"
      }
    }).fetch());
  } catch (error) {
    // If SDMX server has returned an error message
    if (error instanceof RequestErrorEvent && isDefined(error.response)) {
      if (!allowNotImplemeted) {
        throw new TerriaError({
          title: i18next.t("models.sdmxServerStratum.sdmxStructureLoadErrorTitle"),
          message: sdmxErrorString.has(error.statusCode) ? "".concat(sdmxErrorString.get(error.statusCode), ": ").concat(error.response) : "".concat(error.response)
        });
      }
      // Not sure what happened (maybe CORS)
    } else if (!allowNotImplemeted) {
      throw new TerriaError({
        title: i18next.t("models.sdmxServerStratum.sdmxStructureLoadErrorTitle"),
        message: "Unkown error occurred".concat(isDefined(error) ? typeof error === "string" ? ": ".concat(error) : ": ".concat(JSON.stringify(error)) : "")
      });
    }
  }
}
export let SdmxHttpErrorCodes = /*#__PURE__*/function (SdmxHttpErrorCodes) {
  // SDMX to HTTP Error Mapping - taken from https://github.com/sdmx-twg/sdmx-rest/blob/7366f56ac08fe4eed758204e32d2e1ca62c78acf/v2_1/ws/rest/docs/4_7_errors.md#sdmx-to-http-error-mapping
  SdmxHttpErrorCodes[SdmxHttpErrorCodes["NoChanges"] = 304] = "NoChanges";
  // 100 No results found = 404 Not found
  SdmxHttpErrorCodes[SdmxHttpErrorCodes["NoResults"] = 404] = "NoResults";
  // 110 Unauthorized = 401 Unauthorized
  SdmxHttpErrorCodes[SdmxHttpErrorCodes["Unauthorized"] = 401] = "Unauthorized";
  // 130 Response too large due to client request = 413 Request entity too large
  // 510 Response size exceeds service limit = 413 Request entity too large
  SdmxHttpErrorCodes[SdmxHttpErrorCodes["ReponseTooLarge"] = 413] = "ReponseTooLarge";
  // 140 Syntax error = 400 Bad syntax
  SdmxHttpErrorCodes[SdmxHttpErrorCodes["SyntaxError"] = 400] = "SyntaxError";
  // 150 Semantic error = 403 Forbidden
  SdmxHttpErrorCodes[SdmxHttpErrorCodes["SemanticError"] = 403] = "SemanticError";
  SdmxHttpErrorCodes[SdmxHttpErrorCodes["UriTooLong"] = 414] = "UriTooLong";
  // 500 Internal Server error = 500 Internal server error
  // 1000+ = 500 Internal server error
  SdmxHttpErrorCodes[SdmxHttpErrorCodes["ServerError"] = 500] = "ServerError";
  // 501 Not implemented = 501 Not implemented
  SdmxHttpErrorCodes[SdmxHttpErrorCodes["NotImplemented"] = 501] = "NotImplemented";
  // 503 Service unavailable = 503 Service unavailable
  SdmxHttpErrorCodes[SdmxHttpErrorCodes["ServiceUnavailable"] = 503] = "ServiceUnavailable";
  return SdmxHttpErrorCodes;
}({});
export const sdmxErrorString = new Map();
sdmxErrorString.set(SdmxHttpErrorCodes.NoChanges, "No changes");
sdmxErrorString.set(SdmxHttpErrorCodes.NoResults, "No results");
sdmxErrorString.set(SdmxHttpErrorCodes.Unauthorized, "Unauthorised");
sdmxErrorString.set(SdmxHttpErrorCodes.ReponseTooLarge, "Response too large");
sdmxErrorString.set(SdmxHttpErrorCodes.SyntaxError, "Syntax error");
sdmxErrorString.set(SdmxHttpErrorCodes.SemanticError, "Semantic error");
sdmxErrorString.set(SdmxHttpErrorCodes.UriTooLong, "URI too long");
sdmxErrorString.set(SdmxHttpErrorCodes.ServerError, "Server error");
sdmxErrorString.set(SdmxHttpErrorCodes.NotImplemented, "Not implemented");
sdmxErrorString.set(SdmxHttpErrorCodes.ServiceUnavailable, "Service unavailable");